<template>
  <div class="focus-value">
    <div class="focus-value__bars">
      <div v-for="bar in distribution" :key="bar.label" class="focus-value__bar">
        <div
          class="focus-value__bar_inner"
          :style="{
            'background-color': bar.color,
            height: minBarHeight + barHeight * bar.value + 'px',
          }"
        />
        <span class="focus-value__bar-label">
          {{ Math.round(bar.value * 100) }}{{ $t('ui.symbol.percentage') }}
        </span>
        <span class="focus-value__label">{{ bar.label }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FocusDistribution',

  props: {
    distribution: {
      type: Array,
      default: null,
    },
    minBarHeight: {
      type: Number,
      default: 0,
    },
    barHeight: {
      type: Number,
      default: 0,
    },
  },
};
</script>

<style lang="scss">
.focus-value {
  position: relative;
  width: 100%;
  height: 120px;
  display: flex;
}

.focus-value__bars {
  display: flex;
  justify-content: center;
  width: 100%;
}

.focus-value__bar {
  width: 70px;
  height: 80px;
  margin-right: 15px;
  position: relative;
}

.focus-value__bar:last-of-type {
  margin-right: 0px;
}

.focus-value__bar_inner {
  width: 70px;
  height: 20px;
  border-radius: 5px;
  position: absolute;
  left: 0;
  bottom: 0;
}

.focus-value__bar-label {
  position: absolute;
  left: 8px;
  top: 62px;
  text-align: left;
  width: 87px;
  color: $color-black;
  font-weight: bold;
}

.focus-value__label {
  position: absolute;
  left: 0px;
  top: 90px;
  text-align: left;
  width: 87px;
  font-weight: bold;
}
</style>
